import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFooter,{staticStyle:{"z-index":"50"},attrs:{"app":"","height":"50","width":"300","dark":""}},[_c(VSpacer),_c('span',{staticStyle:{"font-size":"20pt"}},[_vm._v(" ₩ ")]),_c(VSpacer)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }